import { InjectionToken } from '@angular/core';

export type CartConfig = {

    shouldProductSubBeUnique:boolean
}

export const CW_CART_CONFIG = new InjectionToken<CartConfig>('CartConfig', {
  factory: () =>  ({
    shouldProductSubBeUnique: false
  } satisfies CartConfig)
});
